export interface ContentChatGptRequestGq {
  id: number;
  systemTemplate: string;
  contentTemplate: string;
}

export const ContentChatGptRequestGqProps = `
  id
  systemTemplate
  contentTemplate
`;
